import request from './request'

/**
 * 创建下载任务（立即返回 taskId，后台异步执行）
 * @param {string} type - 任务类型，如 'bct-review-zip'
 * @param {object} params - 任务参数
 */
export function createDownloadTask(type, params = {}, label = '') {
  return request({
    url: '/download-tasks',
    method: 'post',
    data: { type, params, label },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

/**
 * 查询任务状态
 */
export function getDownloadTaskStatus(taskId) {
  return request({
    url: `/download-tasks/${taskId}`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

/**
 * 下载任务文件（带鉴权，触发浏览器下载）
 */
export async function downloadTaskFile(taskId, fileName) {
  const token = localStorage.getItem('token')
  const url = `/api/download-tasks/${taskId}/download`
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token || ''}`
    }
  })
  if (!response.ok) {
    const text = await response.text()
    let msg = '下载失败'
    try {
      const json = JSON.parse(text)
      msg = json.message || msg
    } catch (e) { void e }
    throw new Error(msg)
  }
  const blob = await response.blob()
  const objectUrl = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = objectUrl
  a.download = fileName || 'download'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(objectUrl)
}
